import { useEffect, useRef } from 'react';
import { isNil } from 'ramda';
import { useEvent } from './useEvent';
export const useInterval = (callback, delay, options = {}) => {
    const { skipFirstRun } = options;
    const excectutionCount = useRef(0);
    const savedCallback = useEvent(callback);
    useEffect(() => {
        if (isNil(delay))
            return;
        excectutionCount.current = excectutionCount.current + 1;
        if (skipFirstRun && excectutionCount.current === 1)
            return;
        const id = setInterval(() => savedCallback?.(), delay);
        return () => clearInterval(id);
    }, [delay, savedCallback, skipFirstRun]);
};
//# sourceMappingURL=useInterval.js.map